import { useEffect, useState } from "react";
import type { DashboardSummaryDto } from "@grizzly/shared";
import { api } from "./api.js";

export function useDashboardSummary(enabled: boolean): DashboardSummaryDto | null {
  const [summary, setSummary] = useState<DashboardSummaryDto | null>(null);

  useEffect(() => {
    if (!enabled) {
      setSummary(null);
      return;
    }
    let cancelled = false;
    api
      .dashboard()
      .then((s) => {
        if (!cancelled) setSummary(s);
      })
      .catch(() => {
        if (!cancelled) setSummary(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return summary;
}
